module.exports = __webpack_public_path__ + "static/img/face4.d5ba5f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/face4.png
// module id = aIjQ
// module chunks = 1